import { VNTABS_SET_TAB_NAME_REQUIRED } from './ActionTypes'

const getInitialState = () => {
  return {
    isTabNameRequired: false,
  }
}

const reducer = (state = getInitialState(), action) => {
  switch (action.type) {
    case VNTABS_SET_TAB_NAME_REQUIRED:
      return {
        ...state,
        isTabNameRequired: !!action.isRequired,
      }
    default:
      return state
  }
}

export default reducer
